module.exports = __webpack_public_path__ + "img/logo-phsargames-image.51cd7761.png";